import React, { useEffect, useState } from "react";
import ProzoDataGrid from "../../../../common/ProzoDataGrid";
import { Box, Button, Typography } from "@mui/material";
import { apiConstants, postGeneric } from "../../../../common/constants";
import { parseDateAndTime } from "../../../../helpers/UtilityHelper";
import MUIModal from "../../../../common/MUIModal";
import ApproveRequest from "../Action";
import AwbLinkCell from "../../../../common/AwbLinkCell";
import Loader from "../../../../common/Loader"
import { getMerchant } from "../../../../helpers/ReduxHelpers";
import ReplayIcon from '@mui/icons-material/Replay';
import { useSnackbar } from "notistack";
import { LoadingButton } from "@mui/lab";
import { primaryTextSx, secondaryTextSx, cellStackSx, awbTextSx } from '../../list2/cellStyles';
import { primaryBtnSx } from '../../../../styles/patterns';
import { FONT, SIZE } from '../../../../styles/foundation/typography';

const AutoApproveFailed = () => {
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [data, setData] = useState([])
    const [dataCount, setCount] = useState(0)
    const [itemModalData, setItemModalData] = useState();
    const [approveModalData, setApproveModalData] = useState();
    const [approveModaOpen, setApproveModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(0);
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        setIsLoading(true)
        const payload = {
            "andfilter": [
                {
                    "field": "itemData.isRequestPlaced",
                    "operator": "eq",
                    "value": true
                },
                {
                    "field": "merchantOid",
                    "operator": "eq",
                    "value": merchantId
                },
                {
                    "field": "isAutoApprovalOrder",
                    "operator": "eq",
                    "value": true
                },
                {
                    "field": "autoApprovalStatus",
                    "operator": "eq",
                    "value": "FAILED"
                },
            ],
            "orfilter": [
                {
                    "field": "itemData.remainingActionableItems",
                    "operator": "gt",
                    "value": 0
                }
            ],
            "offset": page * sizePerPage,
            "limit": sizePerPage,
            "skipCount": true,
            "controllerFilter": true,
            "excludes": "otp"
        }
        postGeneric(`${apiConstants.RETURN_EXCHANGE_ORDER_LIST}?conditionFlag=Pending&offset=${page * sizePerPage}&limit=${sizePerPage}`, payload).then((res) => {
            setCount(res.data?.resultData?.count)
            setData(res.data?.resultData?.data)
            setIsLoading(false)
        }).catch((err) => {
            console.log(err);
            setIsLoading(false)
        })
    }, [page, sizePerPage, reload, merchantId])

    const columns = [
        {
            field: "awbNumber",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Forward AWB",
            flex: 0.7,
            minWidth: 140,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <AwbLinkCell awb={row?.awbNumber} sx={awbTextSx} />
                    </Box>
                )
            },
        },
        {
            field: "shippingLabelId",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Shipping Label ID",
            flex: 0.7,
            minWidth: 140,
        },
        {
            field: "dates",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Dates",
            flex: 1.5,
            minWidth: 240,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={secondaryTextSx}><span style={{ fontWeight: 600 }}>Created:</span> {parseDateAndTime(row.createdDate)}</Typography>
                        <Typography sx={secondaryTextSx}><span style={{ fontWeight: 600 }}>Delivered:</span> {parseDateAndTime(row.deliveryDate)}</Typography>
                        <Typography sx={secondaryTextSx}><span style={{ fontWeight: 600 }}>Return Request Received:</span> {parseDateAndTime(row.orderRequestedDate)}</Typography>
                    </Box>
                );
            },
        },
        {
            field: "autoApprovalOrderFailedReason",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Failed Reason",
            flex: 1,
            minWidth: 160,
        },
        {
            field: "retryStatus",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Retry Status",
            flex: 0.6,
            minWidth: 120,
            renderCell: (params) => {
                const { row } = params;
                return <Typography sx={secondaryTextSx}>{row.retryStatus || 'Pending'}</Typography>
            },
        },
        {
            field: "isAllOrderReturn",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Return Type",
            flex: 1,
            minWidth: 160,
            renderCell: (params) => {
                const { row } = params;
                return row.isAllOrderReturn ? (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>
                            Order wise return
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            Reason : {row?.rvpReason}
                        </Typography>
                    </Box>
                ) : (
                    <Typography sx={secondaryTextSx}>
                        SKU wise return
                    </Typography>
                );

            },
        },
        {
            field: "action",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Action",
            flex: 0.5,
            minWidth: 100,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Button
                        onClick={() => {
                            setApproveModalData(row.itemData);
                            setItemModalData(row);
                            setApproveModalOpen(true);
                        }}
                        sx={{
                            fontFamily: FONT,
                            fontSize: SIZE['2xs'],
                            textTransform: 'none',
                            p: 0,
                            minWidth: 0,
                        }}
                    >
                        View Items
                    </Button>
                )
            },
        },
    ]

    const [selectedRowsData, setSelectedRowsData] = useState([]);

    const handleSelectionModelChange = (newSelection) => {
        const selectedRows = data?.filter(row => newSelection.includes(row.id));
        setSelectedRowsData(selectedRows);
    };
    const [isRetryLoading, setIsRetryLoading] = useState(false);
    const handleRetryFailedReturnOrder = () => {
        setIsRetryLoading(true)
        const awbNumbers = selectedRowsData?.map(row => row.awbNumber);
        postGeneric(`${apiConstants.RETRY_FAILED_RETURN_ORDER}`, awbNumbers).then((res) => {
            enqueueSnackbar(res?.data || "Failed Return Order Re-tried Successfully, Kindly check after some time", { variant: "success" });
        }).catch((err) => {
            enqueueSnackbar(err?.data?.message || "Failed to re-try failed return order", { variant: "error" });
            console.log(err, "err")
        }).finally(() => {
            setIsRetryLoading(false)
        })
    }

    return (
        <>
            {isLoading && <Loader />}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
                <LoadingButton loading={isRetryLoading} startIcon={<ReplayIcon />} size="medium" sx={primaryBtnSx}
                    disabled={selectedRowsData?.length === 0}
                    onClick={() => handleRetryFailedReturnOrder()}>Retry Failed Return Order</LoadingButton>
            </Box>
            <ProzoDataGrid
                columns={columns}
                autoHeight={true}
                rows={data?.length > 0 ? data : []}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                hideFooterPagination={false}
                onSelectionModelChange={handleSelectionModelChange}
                checkboxSelection={true}
                rowCount={dataCount ? dataCount : Number.MAX_VALUE}
                getRowId={(row) => row.id}
            />
            <MUIModal title='Manage Return Request' open={approveModaOpen} handleClose={() => setApproveModalOpen(false)}
                children={<ApproveRequest
                    approveModalData={approveModalData}
                    itemModalData={itemModalData}
                    setApproveModalOpen={setApproveModalOpen}
                    setReload={setReload}
                     />} />
        </>
    );
};

export default AutoApproveFailed
